import get980Inventory from '../../sections/INF-ProductOverview/get980Inventory';

const hideColor = (color) => {
  const colorVariantElements = document.querySelectorAll(`[data-color-variant-selector][data-value="${color}"]`);
  colorVariantElements.forEach((element) => {
    element.style.display = 'none';
  });

  const colorOptions = document.querySelectorAll(`select[data-color-variant-selector] option[value="${color}"]`);
  colorOptions.forEach((option) => {
    option.disabled = true;
  });

  const secondaryColorVariantElements = document.querySelectorAll(
    `[data-secondary-color-variant-selector][data-value="${color}"]`,
  );
  secondaryColorVariantElements.forEach((element) => {
    element.style.display = 'none';
  });
};

const hideSoldOutClearanceColors = (product_json, inventory_json) => {
  const colorVariantIds = {};
  const colorInventories = {};
  const quickViewOpened = document.querySelector('[data-quick-view-content]');

  const hideColors = (new_content) => {
    if (new_content) {
      inventory_json = new_content.color;
    }

    product_json.variants.forEach((item) => {
      if (colorVariantIds[item.option1]) {
        colorVariantIds[item.option1].push(item.id);
      } else {
        colorVariantIds[item.option1] = [item.id];
      }
    });

    const colors = Object.keys(colorVariantIds);

    colors.forEach((color) => {
      const sum = colorVariantIds[color].reduce((acc, val) => {
        return acc + parseInt(inventory_json[val], 10);
      }, 0);

      colorInventories[color] = sum;
    });

    colors.forEach((color) => {
      let shouldHideColor = false;

      // Hide colors with no images
      const imagesForColor = product_json.variants.filter((variant) => {
        return variant.option1 === color && variant.featured_image;
      });

      if (colorInventories[color] < 1) {
        shouldHideColor = true;
      }

      if (imagesForColor.length < 1) {
        shouldHideColor = true;
      }

      if (shouldHideColor) {
        hideColor(color);
      }
    });
  };

  let res = false;
  const country = window.theme.country_iso;
  const compare_type = 'sku';

  if (country === 'US') {
    hideColors((res = false));
  } else if (window.inventory980 && !quickViewOpened) {
    hideColors(window.inventory980);
  } else {
    return new Promise((resolve, reject) => {
      get980Inventory(false, compare_type, product_json)
        .then((result) => {
          res = result;
          resolve(res);
          hideColors(res);
        })
        .catch((error) => {
          reject(error);
          hideColors((res = false));
        });
    });
  }
};

export default hideSoldOutClearanceColors;
